import { render, staticRenderFns } from "./inquiryContact.vue?vue&type=template&id=617e6108&scoped=true"
import script from "./inquiryContact.vue?vue&type=script&lang=js"
export * from "./inquiryContact.vue?vue&type=script&lang=js"
import style0 from "./inquiryContact.vue?vue&type=style&index=0&id=617e6108&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e6108",
  null
  
)

export default component.exports